"use client";

import { SafeHydrate } from "@/SafeHydrate";
import React from "react";
import { Leaf } from "lucide-react";
import { Avatar, AvatarFallback } from "@/components/ui/avatar";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Link } from "@/components/common/Link";
export default function TheVitaApproach() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="239570" id="built-by-a-farmer-for-farmers" className="relative py-24 md:py-32 bg-background text-foreground overflow-hidden">
      {}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-3xl h-full bg-[radial-gradient(ellipse_at_top,_var(--tw-gradient-stops))] from-accent/20 via-transparent to-transparent opacity-60 pointer-events-none" />
      <div ref={ref} className={`container mx-auto px-6 md:px-12 max-w-3xl text-center transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        <div className="flex justify-center mb-10">
          <div className="p-3 rounded-lg bg-accent/30 text-primary ring-1 ring-primary/20">
            <Leaf className="size-6" strokeWidth={1.5} />
          </div>
        </div>
        <h2 className="text-3xl md:text-5xl font-default font-bold text-primary mb-10 tracking-tight">
          Built in the mud, not a boardroom.
        </h2>
        <div className="space-y-8 text-lg md:text-xl text-foreground/80 leading-relaxed font-default font-normal">
          <p>
            BarnDesk started on Blackey Farms, our family's 55-acre place in Castalian Springs, Tennessee. We run Kiko goats, Black Angus cattle, chickens, and bees on land that's been in Lara's family for three generations. The records for all of it lived in three notebooks, a Google Calendar nobody opened, and a stack of receipts in the truck's glovebox.
          </p>
          <p>
            We built the first version of BarnDesk because the farm needed it — FAMACHA scoring for the goats, weight and breeding records for the cattle, a way to sort feed-store receipts onto the right Schedule F line before April crept up again. Every feature in the app started as a problem on this farm first.
          </p>
        </div>
        <div className="mt-12 mb-16 text-left border-l-4 border-primary/30 pl-6 md:pl-8 max-w-2xl mx-auto">
          <blockquote className="font-serif italic text-2xl md:text-[28px] text-[#A7C49A] leading-tight mb-4">
            "I didn't want a software suite. I wanted a tool that worked as hard as my tractor and didn't require a degree to operate."
          </blockquote>
          <cite className="not-italic font-default font-medium text-base md:text-lg text-foreground/90">
            — Bryan Blackwell, co-founder
          </cite>
        </div>
        <div className="mt-16 flex flex-col items-center justify-center space-y-6">
          <SafeHydrate><Avatar className="size-16 md:size-20 border-4 border-accent shadow-md">
            <AvatarFallback className="bg-primary text-primary-foreground text-xl font-serif">BD</AvatarFallback>
          </Avatar></SafeHydrate>
          
          <div className="flex flex-col items-center space-y-1">
            <Link to="https://blackeyfarms.com" newTab rel="noopener noreferrer">
              <span className="font-serif italic text-2xl md:text-3xl text-primary">
                Visit Blackey Farms
              </span>
            </Link>
            <span className="text-xs md:text-sm text-muted-foreground uppercase tracking-widest font-semibold">
              Built by a Farmer
            </span>
          </div>
        </div>
      </div>
    </section>;
}